"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Thu Aug 23 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * CompetitorProductConverter
 *
 * @author RV
 */


var CompetitorProductConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(CompetitorProductConverter, _DataObjectConverter_);

  function CompetitorProductConverter() {
    _classCallCheck(this, CompetitorProductConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompetitorProductConverter).apply(this, arguments));
  }

  return CompetitorProductConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.CompetitorProductConverter = CompetitorProductConverter;